import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

/** Sidebar section labels — never show as path crumbs (§2.13). */
export const NAV_GROUP_LABELS = new Set([
  'Data',
  'Pipeline',
  'Matching',
  'Outreach',
  'Automations',
  'Workspace',
  'Main',
  'People',
  'Work',
  'System',
]);

function collapseBreadcrumbItems(items: BreadcrumbItem[]): BreadcrumbItem[] {
  const filtered = items.filter((it) => !NAV_GROUP_LABELS.has(it.label));
  if (filtered.length <= 2) return filtered;
  const first = filtered[0]!;
  const last = filtered[filtered.length - 1]!;
  return [first, { label: '…' }, last];
}

export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const display = collapseBreadcrumbItems(items);
  return (
    <nav className="flex items-center gap-1 text-[13px]" aria-label="Breadcrumb">
      {display.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="w-3.5 h-3.5 vscode-text-tertiary opacity-80" aria-hidden />}
          {item.label === '…' ? (
            <span className="vscode-text-tertiary" aria-hidden>
              …
            </span>
          ) : item.href ? (
            <Link to={item.href} className="vscode-text-link transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="vscode-text-secondary">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
